// extracted by mini-css-extract-plugin
export default {"tables":"ReportMenu_tables__BiV4T","iframe":"ReportMenu_iframe__TyTjM"};